<div class="course-details-container">
  <div class="header">
    <div class="top">
      <div class="title">
        <div class="main-title">{{ courseDetails?.course?.category }}</div>
        <div class="sub-title">An overview of your course</div>
      </div>
    </div>
    <div class="bottom">
      <div class="back" (click)="onClickBack()">&lt; back</div>
    </div>
  </div>
  <div class="course-preview">
    <div class="top">
      <div class="title">
        <div class="main-title">{{ courseDetails?.course?.title }}</div>
        <div class="sub-title">
        </div>
      </div>
      <div class="icon">
        <img src="../../../assets/images/icon-16.png" alt="" />
      </div>
    </div>
    <div class="preview">
      <div class="left">
        <div class="title">{{ previewLesson?.title }}</div>
        <div class="desc">
          {{ previewLesson?.description }}
        </div>
        <div class="video" *ngIf="previewLesson">
          <video id="videoPlayer" width="100%" controls>
            <source [src]="
                apiURL +
                '/api/course/' +
                courseId +
                '/module/' +
                +previewLesson?.moduleId +
                '/lesson/' +
                previewLesson?._id +
                '/video/' +
                previewLesson?.video
              " type="video/mp4" />
          </video>
        </div>
      </div>
      <div class="right">
        <div class="content">
          <div class="title">Description</div>
          <div class="desc">
            {{ courseDetails?.course?.description }}
          </div>
        </div>
        <div class="duration" *ngIf="courseDetails?.course?.duration">
          <div class="title"> Duration </div>
          <div class="desc"> {{ courseDetails?.course?.duration }} </div>
        </div>
        <div class="requirements" *ngIf="courseRequirements.length">
          <div class="title">Requirements</div>
          <ul>
            <li *ngFor="let req of courseRequirements">{{ req }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="course-instructions">
    <div class="what-to-learn">
      <div class="title">What you will learn</div>
      <div class="left-right" *ngIf="toLearn.length">
        <div class="left">
          <div class="instruction" *ngFor="let learn of toLearn; let i = index">
            <div class="icon" *ngIf="i <= 3">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="text" *ngIf="i <= 3">
              {{ learn }}
            </div>
          </div>
        </div>
        <div class="right">
          <ng-container *ngFor="let learn of toLearn; let i = index">
            <div class="instruction" *ngIf="i > 3">
              <div class="icon">
                <i class="fa-solid fa-circle-check"></i>
              </div>
              <div class="text">
                {{ learn }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="who-learn">
      <div class="title">Who this is for</div>
      <div class="instruction" *ngFor="let whom of toWhom">
        <div class="icon">
          <i class="fa-solid fa-circle-check"></i>
        </div>
        <div class="text">
          {{ whom }}
        </div>
      </div>
    </div>
  </div>
  <div class="course-contents">
    <div class="title">Course Contents</div>
    <div class="modules-and-lessons">
      <div class="modules">
        <div class="label">Modules</div>
        <div class="module" (click)="onClickModule(module)" [ngClass]="{ active: selectedModuleId == module._id }"
          *ngFor="let module of modules">
          <div class="top">
            <div class="name">{{ module?.title }}</div>
          </div>
          <div class="duration">{{ module.duration }}</div>
          <div class="desc">
            {{ module?.description }}
          </div>
        </div>
      </div>
      <div class="lessons">
        <div class="label">Lessons</div>
        <div class="lesson" *ngFor="let lesson of lessons">
          <div class="top">
            <div class="name">{{ lesson.title }}</div>
          </div>
          <div class="duration">{{ lesson.duration }}</div>
          <div class="desc">
            {{ lesson.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="buy-add-btns" *ngIf="!authService.isAdmin">
    <button class="buy-now" (click)="onClickBuyNow()" *ngIf="!isPurchased && !isProMember() && !isSampleCourse()">
      Subscribe Now
    </button>
    <button class="buy-now" (click)="onClickEnrollNow()" *ngIf="!isPurchased && isProMember() && !enrollNowLoading">
      {{ !isSampleCourse() ? 'Enroll Now' : 'Go to Course' }}
    </button>
    <button class="buy-now" (click)="onClickEnrollNow()" *ngIf="!isPurchased && isProMember() && enrollNowLoading">
      Loading <i class="fa-solid fa-spinner fa-spin"></i>
    </button>
    <button class="play-course" (click)="onClickPlay()" *ngIf="isPurchased || isSampleCourse()">
      Go to Course
    </button>
  </div>
  <div class="related-courses" *ngIf="relatedCourses.length > 0">
    <div class="title">People also checked out ...</div>
    <div class="content">
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ab veritatis
      sunt dolore ipsam, impedit, et quisquam praesentium atque perferendis quas
      ad at libero reiciendis nobis fugiat ipsum adipisci deleniti sapiente.
    </div>
    <div class="scrollable-courses">
      <div class="left-arrow" (click)="scrollLeft()">
        <i class="fa-solid fa-angle-left"></i>
      </div>
      <div #courses class="courses">
        <div class="course" *ngFor="let course of relatedCourses">
          <div class="thumbnail">
            <img [src]="'data:image/jpeg;base64,' + course?.thumbnail?.buffer" alt="" />
          </div>
          <div class="title-section">
            <div class="left">
              <div class="name">{{ course?.title }}</div>
              <!-- <div class="duration">duration</div> -->
            </div>
            <div class="right">
              <button (click)="onClickKnowMore(course)">Know More</button>
            </div>
          </div>
          <div class="description">
            {{ course?.description }}
          </div>
        </div>
      </div>
      <div class="right-arrow" (click)="scrollRight()">
        <i class="fa-solid fa-angle-right"></i>
      </div>
    </div>
  </div>
  <div class="categories">
    <div *ngFor="let category of categories" class="topic" (click)="onSelectTopic(category)"
      [ngClass]="{ 'active-topic': selectedTopic == category }">
      {{ category }}
    </div>
  </div>
</div>